import React, { useRef } from 'react';
import Scene3D from './Scene3D';
import ControlButtons from './ControlButtons';
import ConsoleLog from './ConsoleLog';

interface MainContentProps {
    animationState: string;
    setAnimationState: (state: string) => void;
    consoleMessages: string[];
}

const MainContent: React.FC<MainContentProps> = ({ animationState, setAnimationState, consoleMessages }) => {
    const mountRef = useRef<HTMLDivElement>(null);

    return (
        <main className="flex flex-col items-center justify-center flex-grow w-full max-w-7xl mx-auto my-8 p-6 bg-gray-800 rounded-lg shadow-lg relative overflow-hidden">
            <h2 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300 mb-6 text-center">
                数字孪生赋能智能制造
            </h2>
            <p className="text-lg text-gray-300 mb-8 text-center max-w-3xl">
                通过先进的工业视觉技术，将物理世界精确地数字化，实现生产过程的实时监控、分析与优化。
            </p>

            {/* 3D 渲染区域 */}
            <div ref={mountRef} className="w-full h-[60vh] bg-gray-700 rounded-lg overflow-hidden mb-8 relative">
                <Scene3D mountRef={mountRef} />
                
                {/* 无人机视角窗口边框 */}
                <div className="absolute right-5 top-5 w-[25%] h-[25%] border-2 border-blue-400 rounded-lg pointer-events-none z-30 flex items-center justify-center text-sm bg-gray-900 bg-opacity-50 text-white">
                    <span className="p-2">无人机视角</span>
                </div>
                
                {/* 加载指示器 */}
                {animationState !== 'idle' && (
                    <div className="absolute inset-0 flex items-center justify-center bg-gray-900 bg-opacity-75 text-white text-xl z-20">
                        正在数字化...
                    </div>
                )}
            </div>

            {/* 控制按钮 */}
            <ControlButtons animationState={animationState} setAnimationState={setAnimationState} />
            <ConsoleLog messages={consoleMessages} />
        </main>
    );
};

export default MainContent; 